import ReactSelect from 'react-select';
import PropTypes from 'prop-types';
export const BuildingOrientation = ({
  values,
  handleChangeCaracObj,
  errors,
  touched
}) => {
  const options = [
    { value: '', label: 'Seleccione' },
    { value: 1, label: 'Norte' },
    { value: 2, label: 'Sur' },
    { value: 3, label: 'Este' },
    { value: 4, label: 'Oeste' }
  ];
  return (
    <div>
      <label>Orientación de la propiedad</label>
      <ReactSelect
        name="buildingOrientation"
        placeholder="-- Seleccione la Orientación --"
        options={options}
        value={options.find(v => v.value === values)}
        onChange={e => {
          handleChangeCaracObj(
            'buildingOrientation',
            e?.value && Number(e.value)
          );
        }}
      />
      {errors?.type && touched?.type && (
        <label className="w-100 text-danger">{errors.type}</label>
      )}
    </div>
  );
};

BuildingOrientation.propTypes = {
  values: PropTypes.object,
  handleChangeCaracObj: PropTypes.func,
  errors: PropTypes.object,
  touched: PropTypes.object
};
